import React from "react"
import SiteNavMenu from "./SiteNavMenu"

export default function SiteNavDropdown({ close }) {
  return <SiteNavMenu close={close} dropdown />
}
